import React, { useMemo } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
import { DownloadStoriesPreviewModel } from '@/types/home';
import { cn } from '@/lib/utils';

const WhyDownloadStoriesContent = ({
  data,
}: {
  data?: {
    title?: string;
    desc?: string;
    cards?: {
      title?: string;
      desc?: string;
      imgPath?: string;
    }[];
  };
}) => {
  // const section4 = contentData?.contentInfo?.['section-4'];

  const getContent = useMemo(() => {
    return data ? (
      <div className={styles.content}>
        {data?.title && <h2 className={cn(styles.title, { 'mb-[3.125rem]': !data?.desc })}>{data?.title}</h2>}

        {data?.desc && <p className="mt-8 mb-[3.125rem] text-[1.125rem] leading-6 text-center">{data?.desc}</p>}

        <div className={classNames([styles.contentList, data?.cards?.length > 3 && styles.contentListMore])}>
          {data?.cards?.length > 0 &&
            data?.cards?.map((item, index) => (
              <div className={styles.contentItem} key={index}>
                <div className={classNames(styles.contentItemTitle)}>
                  <Image src={item.imgPath} alt={''} width={64} height={64} />
                  <h3 className={styles.subTitle}>{item.title}</h3>
                </div>
                <p className={styles.subDesc}>{item.desc}</p>
              </div>
            ))}
        </div>
      </div>
    ) : null;
  }, [data]);

  return getContent;
};

export default WhyDownloadStoriesContent;
